// extracted by mini-css-extract-plugin
export default {"sectionHead":"ClientGiftCardsSection_sectionHead__2Cp5S","emptyState":"ClientGiftCardsSection_emptyState__0n4am"};